/* eslint-disable prettier/prettier */
import { Response } from 'models/response';
import { generateGuid } from 'utils/generic';

import { profile, travel, axiosConfig } from '../api';

export const updateUserIsActive = async (email: string, isActive: boolean, registerUserNetSuite: boolean, type: number, username: string, password: string) =>
  profile.put<Response<void>>(
    '/Users/UpdateUserIsActive/00000000-0000-0000-0000-000000000000',
    {
      email,
      isActive,
      registerUserNetSuite,
      type,
      id: '00000000-0000-0000-0000-000000000000',
      companyId: '00000000-0000-0000-0000-000000000000',
      username,
      password
    },
    axiosConfig,
  );

export const payTravel = async (
  extraChargeItineraryId: number,
  originalTravelItineraryId: number,
  description: string,
  emailUser: string,
  countryId: string,
  costCenter: string
) =>
  travel.post<Response<void>>(
    '/Travels/PayTravel',
    {
      extraChargeItineraryId,
      originalTravelItineraryId,
      description,
      emailUser,
      correlationId: generateGuid(),
      countryId,
      costCenter
    },
    axiosConfig,
  );

  export const addImplementator = async (
    companyDocumentNumber: string,
    name: string,
    lastName: string,
    email: string,
    username: string,
  ) =>
    profile.post<Response<any>>(
      'Users/CreateSupportImplementationUser',
      {
        companyDocumentNumber,
        name,
        lastName,
        email,
        username,
      },
      axiosConfig,
    );

    export const updateItinerary = async (
      travelItineraryId: string
    ) =>
      travel.post<Response<any>>(
        'Travels/UpdateStatusTravel',
        {
          travelItineraryId
        },
        axiosConfig,
      );
  
  export const sendTravelToApprove = async (
    travelItineraryId: string
  ) =>
    travel.post<Response<any>>(
      'Travels/SendTravelToApprove',
      {
        travelItineraryId
      },
      axiosConfig,
    );

  export const forcePayment = async (
    travelItineraryId: string,
    companyId: string,
    rappiToken: string,
  ) =>
    travel.put<Response<any>>(
      'Travels/ForcePayment',
      {
        TravelItineraryId: travelItineraryId,
        CompanyId: companyId,
        RappiToken: rappiToken,
      },
      axiosConfig,
    );
  
  export interface CreateUsersMassiveViewModel {
    success: boolean;
    totalRequested: number;
    totalSuccess: number;
    totalError: number;
    messageError: string;
    messageErrorStackTrace: string;
  }

  export const importMassiveUser = async (
    data: FormData
  ): Promise<Response<CreateUsersMassiveViewModel>> => {
    const config = {
      headers: {
       'content-type': 'multipart/form-data',
      },
    };

    return profile
      .post<Response<CreateUsersMassiveViewModel>>('users/UploadUserMassive', data, config)
      .then((response) => response.data) 
      .catch((error) => {
        throw error.response?.data || error;
      });
  };
  